/**
 * Dashboard Layout Component
 * Main layout with sidebar navigation
 */

import { ReactNode } from 'react';
import { Sidebar } from './Sidebar';

interface DashboardLayoutProps {
  children: ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content Area */}
      <main className="flex-1 overflow-y-auto">
        <div className="w-full h-full p-6 md:p-8">
          {children}
        </div>
      </main>
    </div>
  );
}
